import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Richmond Cannabis · Informational Hub</p>
        <h1>Stay Informed on Cannabis Policy and Culture</h1>
        <p className="lede">
          Explore the latest updates, legal insights, and educational resources surrounding cannabis policy in Richmond. Our mission is to provide comprehensive coverage and foster informed discussions about cannabis culture in our community.
        </p>
        <div className="cta-row">
          <a href="/updates" target="_self">
            Latest Policy Updates
          </a>
          <a href="/education" target="_self" className="secondary">
            Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay up-to-date with the latest changes in cannabis legislation and regulations affecting Richmond. Our coverage includes city council meetings, state law revisions, and community initiatives.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Navigate the complexities of cannabis legality in Richmond. We provide clear information on what is permitted, what remains prohibited, and how these laws impact residents and visitors alike.
          </p>
        </article>
        <article>
          <h2>Educational Insights</h2>
          <p>
            Access a wealth of knowledge about cannabis culture, health implications, and responsible use. Our educational content aims to empower the community with factual information and resources.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;